import {Container, Col, Row }from 'react-bootstrap';

import { ArrowRightSquare } from 'react-bootstrap-icons';


interface ContentProps{
    title: string;
    subtitle: string;
    action: () => void;
}

function SmallInfoCard({title, subtitle, action}: ContentProps){
    return (
        <> 

                    <Container className="border small-info-container" onClick={action}>
                        <Row>
                            <p className="py-0 text-start font-body font-size-small">{title}</p>
                        </Row>
                        <Row className="">
                            <Col>
                                <h3 className="py-0 text-start font-body font-size-tiny">{subtitle}</h3>
                            </Col>
                        </Row>
                        <Row className="">
                            <Col className="text-end font-size-tiny pr-0">
                                Read More <ArrowRightSquare className="" size={16}/>
                            </Col>
                        </Row>
                    </Container>


        </>
    )
}

export default SmallInfoCard;